function HeaderDefault() {
  return (
    <div className="logoHeader">
      <p className="AL-txt">Enlace by Aranda\Lasch</p>
    </div>
  );
}

export default HeaderDefault;